import { RowSelectionState, OnChangeFn } from '@tanstack/react-table';
import { useState } from 'react';

type UseTable = {
  rowSelection: RowSelectionState;
  setRowSelection: OnChangeFn<RowSelectionState>;
};

const useTable = (): UseTable => {
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});

  return {
    rowSelection,
    setRowSelection
  };
};

export default useTable;
